import { Tooltip } from "@mui/material";
import { memo } from "react";
import { Link } from "react-router-dom";
import { StyledMenuItem } from "../../styled/Layout";

const ListItemComponent = ({
  path,
  selected,
  title,
  icon: Icon,
  id,
  tooltip,
  tooltipText,
}) => {

  return (
    <>
      {tooltip ? (
        <Tooltip title={tooltipText} placement="bottom" arrow>
          <StyledMenuItem.Nested
            component={Link}
            to={path}
            id={id}
            itemSelected={selected}
          >
            <StyledMenuItem.Icon itemSelected={selected}>{Icon}</StyledMenuItem.Icon>
            <StyledMenuItem.Text itemSelected={selected}>{title}</StyledMenuItem.Text>
          </StyledMenuItem.Nested>
        </Tooltip>
      ) : (
        <StyledMenuItem.Nested
          component={Link}
          to={path}
          id={id}
          itemSelected={selected}
        >
          <StyledMenuItem.Icon itemSelected={selected}>{Icon}</StyledMenuItem.Icon>
          <StyledMenuItem.Text itemSelected={selected}>{title}</StyledMenuItem.Text>
        </StyledMenuItem.Nested>
      )}
    </>
  );
};

export default memo(ListItemComponent);
